import { CALL_API } from "admin/middlewares/api";

export const FACTORING_CREATE_REQUEST = "FACTORING_CREATE_REQUEST";
export const FACTORING_CREATE_SUCCESS = "FACTORING_CREATE_SUCCESS";
export const FACTORING_CREATE_ERROR = "FACTORING_CREATE_ERROR";

export function create_factoring(postData) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/marketplace-lending",
      authenticatedRequest: true,
      method: "POST",
      data: { ...postData },
      types: [
        FACTORING_CREATE_REQUEST,
        FACTORING_CREATE_SUCCESS,
        FACTORING_CREATE_ERROR,
      ],
    },
  };
}

export const GET_FACTORING_APPLICATIONS_REQUEST =
  "GET_FACTORING_APPLICATIONS_REQUEST";
export const GET_FACTORING_APPLICATIONS_SUCCESS =
  "GET_FACTORING_APPLICATIONS_SUCCESS";
export const GET_FACTORING_APPLICATIONS_ERROR =
  "GET_FACTORING_APPLICATIONS_ERROR";

export function get_factoring_applications() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/mpl/credits",
      authenticatedRequest: true,
      types: [
        GET_FACTORING_APPLICATIONS_REQUEST,
        GET_FACTORING_APPLICATIONS_SUCCESS,
        GET_FACTORING_APPLICATIONS_ERROR,
      ],
    },
  };
}

export const GET_FACTORING_INVOICE_REQUEST = "GET_FACTORING_INVOICE_REQUEST";
export const GET_FACTORING_INVOICE_SUCCESS = "GET_FACTORING_INVOICE_SUCCESS";
export const GET_FACTORING_INVOICE_ERROR = "GET_FACTORING_INVOICE_ERROR";

export function get_factoring_invoice(id) {
  return {
    [CALL_API]: {
      endpoint: `/api/admin/factoring/invoice/by-credstep-id?id=${id}`,
      authenticatedRequest: true,
      types: [
        GET_FACTORING_INVOICE_REQUEST,
        GET_FACTORING_INVOICE_SUCCESS,
        GET_FACTORING_INVOICE_ERROR,
      ],
    },
  };
}

export function get_factoring_invoices() {
  return {
    [CALL_API]: {
      endpoint: `/api/admin/facttoring/invoices`,
      authenticatedRequest: true,
      types: [
        GET_FACTORING_INVOICE_REQUEST,
        GET_FACTORING_INVOICE_SUCCESS,
        GET_FACTORING_INVOICE_ERROR,
      ],
    },
  };
}

export const FACTORING_LIST_CHANGE_PAGE = "FACTORING_LIST_CHANGE_PAGE";

export function change_factoring_list_page(page) {
  return {
    type: FACTORING_LIST_CHANGE_PAGE,
    page,
  };
}

export const FACTORING_LIST_CHANGE_FILTER = "FACTORING_LIST_CHANGE_FILTER";

export function change_factoring_list_filter(key, value) {
  let filter = {};
  filter[key] = value;

  return {
    type: FACTORING_LIST_CHANGE_FILTER,
    filter,
  };
}

export const FACTORING_ADD_INVOICE_FEE_REQUEST =
  "FACTORING_ADD_INVOICE_FEE_REQUEST";
export const FACTORING_ADD_INVOICE_FEE_SUCCESS =
  "FACTORING_ADD_INVOICE_FEE_SUCCESS";
export const FACTORING_ADD_INVOICE_FEE_ERROR =
  "FACTORING_ADD_INVOICE_FEE_ERROR";

export function add_factoring_invoice_row(sendData) {
  return {
    [CALL_API]: {
      endpoint: `/api/admin/factoring/add-invoice-row`,
      authenticatedRequest: true,
      method: "POST",
      data: sendData,
      types: [
        FACTORING_ADD_INVOICE_FEE_REQUEST,
        FACTORING_ADD_INVOICE_FEE_SUCCESS,
        FACTORING_ADD_INVOICE_FEE_ERROR,
      ],
    },
  };
}
